import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import './Textos_legales.css';

function TextosLegales() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const el = document.getElementById(location.hash.replace('#', ''));
      if (el) {
        setTimeout(() => el.scrollIntoView({ behavior: 'smooth', block: 'start' }), 100);
      }
    } else {
      window.scrollTo(0, 0);
    }
  }, [location]);

  return (
    <div className="tl-container">
      {/* Logo */}
      <div className="tl-logo-bar">
        <img
          src={`${process.env.REACT_APP_UPLOADS_URL}/logotipo_new8.jpg`}
          alt="Ulalaaa"
          className="tl-logo"
        />
      </div>

      <div className="tl-content">

        {/* NAV INTERNO */}
        <div className="tl-nav">
          <a href="#terminos" className="tl-nav-link">Términos y Condiciones</a>
          <span className="tl-nav-sep">|</span>
          <a href="#privacidad" className="tl-nav-link">Política de Privacidad</a>
          <span className="tl-nav-sep">|</span>
          <a href="#cookies" className="tl-nav-link">Política de Cookies</a>
        </div>

        {/* --------------------------------------
            SECCIÓN 1 — TÉRMINOS Y CONDICIONES
        -------------------------------------- */}
        <section id="terminos" className="tl-section">
          <h1 className="tl-main-title">Términos y Condiciones de Uso</h1>
          <p className="tl-fecha">Última actualización: junio de 2026</p>

          <div className="tl-aviso-adultos">
            ? SITIO EXCLUSIVO PARA MAYORES DE 18 AÑOS
          </div>

          <h2 className="tl-titulo">1. Aceptación de los Términos</h2>
          <p className="tl-parrafo">
            Al acceder, navegar o utilizar la plataforma Ulalaaa (en adelante "el Sitio"), usted declara
            haber leído, comprendido y aceptado en su totalidad los presentes Términos y Condiciones de Uso,
            así como la Política de Privacidad y la Política de Cookies adjuntas. Si no está de acuerdo con
            alguna de estas condiciones, debe abandonar el Sitio de inmediato.
          </p>
          <p className="tl-parrafo">
            El uso continuado del Sitio constituye una aceptación expresa de los presentes términos. Ulalaaa
            se reserva el derecho de modificar estas condiciones en cualquier momento, publicando la versión
            actualizada en esta misma página.
          </p>

          <h2 className="tl-titulo">2. Descripción del Servicio</h2>
          <p className="tl-parrafo">
            Ulalaaa es una <strong>plataforma publicitaria digital</strong> que permite a personas mayores
            de 18 años publicar anuncios de servicios de acompañamiento y similares. El Sitio actúa
            exclusivamente como intermediario publicitario y <strong>no es una agencia de escorts, no
            contrata personas, no interviene en ninguna relación laboral, ni tiene participación en los
            acuerdos privados entre los usuarios</strong>.
          </p>
          <p className="tl-parrafo">
            Ulalaaa no es responsable de las negociaciones, acuerdos, encuentros ni transacciones que
            pudieran producirse entre los usuarios del Sitio. Toda responsabilidad derivada de dichas
            interacciones recae exclusivamente en las partes involucradas.
          </p>

          <h2 className="tl-titulo">3. Requisito de Edad — Mayor de 18 Años</h2>
          <p className="tl-parrafo">
            El acceso y uso del Sitio está <strong>estrictamente prohibido para menores de 18 años</strong>,
            tanto para visitantes como para personas que deseen publicar anuncios. Al ingresar al Sitio,
            usted declara bajo su responsabilidad personal ser mayor de 18 años.
          </p>
          <p className="tl-parrafo">
            Las personas publicantes deberán acreditar su mayoría de edad mediante la presentación de
            documentos de identidad válidos durante el proceso de verificación. La falsificación de datos
            o el uso de identidad ajena constituye un delito y será denunciado a las autoridades competentes.
          </p>

          <h2 className="tl-titulo">4. Proceso de Registro y Verificación para Publicantes</h2>
          <p className="tl-parrafo">
            Para publicar un anuncio en Ulalaaa, la persona interesada debe completar obligatoriamente
            el siguiente proceso:
          </p>
          <ul className="tl-lista">
            <li>Completar el formulario de registro con información veraz y actualizada.</li>
            <li>Proporcionar documentos de identidad válidos que acrediten ser mayor de 18 años y que
            la persona en las fotografías o videos corresponde a quien solicita la publicación.</li>
            <li>Grabar y enviar un <strong>video de verificación</strong> en el que la persona declara
            expresamente, de forma voluntaria y sin coerción, que autoriza su publicación en el Sitio,
            que es mayor de 18 años, y que comprende la naturaleza del servicio publicitario.</li>
            <li>El equipo de Ulalaaa revisará la documentación y el video de verificación antes de
            aprobar cualquier publicación. El proceso de revisión puede tomar hasta 72 horas hábiles.</li>
            <li>Ulalaaa se reserva el derecho de rechazar solicitudes de publicación sin necesidad
            de entregar justificación, a su sola discreción.</li>
          </ul>

          <h2 className="tl-titulo">5. Normas de Publicación y Contenido Prohibido</h2>
          <p className="tl-parrafo">
            Al publicar un anuncio en Ulalaaa, el usuario acepta que el contenido cumple con las
            siguientes normas:
          </p>
          <ul className="tl-lista">
            <li>Toda la información, fotografías y videos publicados son reales, actuales y pertenecen
            a la persona que realiza la publicación.</li>
            <li>Está <strong>estrictamente prohibido</strong> utilizar fotografías, videos o cualquier
            material que pertenezca a terceras personas sin su consentimiento expreso y por escrito.</li>
            <li>Está <strong>estrictamente prohibido</strong> publicar contenido que involucre menores
            de edad en cualquier forma.</li>
            <li>Está prohibido utilizar el Sitio para actividades ilegales, de tráfico de personas,
            explotación, coerción o cualquier forma de abuso.</li>
            <li>El publicante declara actuar de forma completamente libre y voluntaria.</li>
          </ul>
          <p className="tl-parrafo">
            El incumplimiento de cualquiera de estas normas resultará en la eliminación inmediata del
            anuncio y en el bloqueo permanente de la cuenta. Ulalaaa se reserva el derecho de denunciar
            infracciones graves a las autoridades competentes.
          </p>

          <h2 className="tl-titulo">6. Sistema de Intentos y Bloqueo de Cuenta</h2>
          <p className="tl-parrafo">
            El publicante dispone de <strong>dos (2) intentos</strong> para publicar su anuncio utilizando
            la misma cuenta de correo electrónico. En caso de que su publicación sea rechazada por tercera
            vez, se procederá al bloqueo definitivo de la cuenta y a la imposibilidad de continuar el
            proceso, debido al uso incorrecto de la plataforma o al incumplimiento de las políticas
            establecidas.
          </p>

          <h2 className="tl-titulo">7. Planes de Suscripción y Pagos</h2>
          <p className="tl-parrafo">
            La publicación de anuncios en Ulalaaa está sujeta al pago de una suscripción según los
            planes disponibles en el Sitio. Los planes contemplan distintos niveles de visibilidad
            y beneficios para el publicante.
          </p>
          <ul className="tl-lista">
            <li>Los precios de los planes se expresan en pesos chilenos (CLP) e incluyen los impuestos
            correspondientes cuando aplique.</li>
            <li>El pago debe realizarse para activar o renovar la publicación. Sin pago confirmado,
            la publicación no será activada.</li>
            <li><strong>No se realizan devoluciones</strong> una vez activado el plan, salvo que Ulalaaa
            haya cometido un error en el procesamiento del pago, caso en el cual el usuario debe
            comunicarse dentro de las 48 horas siguientes.</li>
            <li>Ulalaaa se reserva el derecho de modificar los precios de los planes con previo aviso
            de 15 días mediante publicación en el Sitio.</li>
            <li><strong>Cancelación anticipada:</strong> el publicante puede solicitar la baja de su
            publicación en cualquier momento escribiendo a infoulalaaa@gmail.com. El perfil será
            despublicado de forma inmediata. No obstante, <strong>no se realizará devolución del
            monto pagado</strong> bajo ninguna circunstancia, dado que el servicio publicitario fue
            activado. Los datos e información del perfil permanecerán almacenados internamente
            por hasta 1 año como respaldo legal, sin ser visibles en el Sitio.</li>
          </ul>

          <h2 className="tl-titulo">8. Sistema de Valoración por Viewers</h2>
          <p className="tl-parrafo">
            El Sitio cuenta con un sistema de valoración donde los usuarios registrados como "Viewers"
            pueden calificar a los publicantes. Las valoraciones son públicas y visibles en el perfil
            de cada publicante.
          </p>
          <p className="tl-parrafo">
            Ulalaaa se reserva el derecho de pausar o no renovar la publicación de perfiles que
            acumulen valoraciones consistentemente negativas, a criterio del equipo administrador.
            Este sistema busca mantener la calidad y confianza de la plataforma.
          </p>

          <h2 className="tl-titulo">9. Propiedad Intelectual</h2>
          <p className="tl-parrafo">
            El nombre "Ulalaaa", el logotipo, el diseño del Sitio y todos los elementos gráficos son
            propiedad de Ulalaaa. Queda prohibida su reproducción, distribución o uso sin autorización
            previa y por escrito.
          </p>
          <p className="tl-parrafo">
            El contenido multimedia (fotografías, videos) subido por los publicantes es responsabilidad
            exclusiva de estos. El publicante declara ser el titular de los derechos del material subido
            o contar con autorización expresa del titular para su uso.
          </p>

          <h2 className="tl-titulo">10. Limitación de Responsabilidad</h2>
          <p className="tl-parrafo">
            Ulalaaa no garantiza la exactitud, veracidad o actualidad del contenido publicado por los
            usuarios. El Sitio actúa como intermediario publicitario y no valida ni avala la calidad,
            legalidad ni resultado de los servicios ofrecidos por los publicantes.
          </p>
          <p className="tl-parrafo">
            Ulalaaa no será responsable por daños directos, indirectos, incidentales o consecuentes
            derivados del uso del Sitio o de las interacciones entre usuarios.
          </p>

          <h2 className="tl-titulo">11. Reporte de Contenido Abusivo o Uso No Autorizado de Imagen</h2>
          <p className="tl-parrafo">
            Si usted considera que algún contenido publicado en el Sitio utiliza su imagen, datos
            personales u otro material sin su consentimiento, o si detecta contenido ilegal, puede
            reportarlo escribiendo a{' '}
            <a href="mailto:infoulalaaa@gmail.com" className="tl-link">infoulalaaa@gmail.com</a>
            {' '}indicando: su nombre completo, el enlace o descripción del contenido, y el motivo
            del reporte.
          </p>
          <p className="tl-parrafo">
            Ulalaaa revisará el reporte dentro de un plazo máximo de <strong>72 horas hábiles</strong> y,
            de verificarse la infracción, procederá a retirar el contenido de forma inmediata.
          </p>

<h2 className="tl-titulo">12. Legislación Aplicable</h2>
          <p className="tl-parrafo">
            Los presentes Términos y Condiciones se rigen por las leyes de la República de Chile.
            Cualquier disputa derivada del uso del Sitio será sometida a los tribunales competentes
            de la ciudad de Santiago de Chile.
          </p>

          <h2 className="tl-titulo">13. Contacto Directo con Publicantes</h2>
          <p className="tl-parrafo">
            El Sitio ofrece botones de contacto directo (llamada telefónica, WhatsApp, Telegram) que
            redirigen al usuario fuera de la plataforma, hacia una conversación privada con el
            publicante. Al utilizar estos botones, el usuario reconoce que dicha conversación se
            realiza por su cuenta y riesgo, y que Ulalaaa no participa, supervisa ni se responsabiliza
            de su contenido ni consecuencias.
          </p>

          <h2 className="tl-titulo">14. Videos Promocionales, Contenido de Plataforma y Gestión del Material Publicado</h2>
          <p className="tl-parrafo">
            Al aceptar publicar en Ulalaaa, el publicante autoriza expresamente la producción y
            difusión de <strong>material promocional</strong> vinculado a su perfil, bajo las siguientes
            condiciones:
          </p>
          <ul className="tl-lista">
            <li>
              <strong>Videos promocionales no explícitos:</strong> Ulalaaa podrá producir o solicitar
              al publicante la grabación de videos de presentación, entrevistas o contenido promocional
              del sitio. Este material es de carácter no explícito y podrá ser difundido en las
              <strong> redes sociales administradas por Ulalaaa</strong> (Instagram, TikTok, X u otras
              plataformas) con el fin de promover el sitio y captar audiencia. El publicante que desee
              mantener su rostro oculto en este material deberá solicitarlo expresamente por escrito
              a <a href="mailto:infoulalaaa@gmail.com" className="tl-link">infoulalaaa@gmail.com</a>,
              y Ulalaaa tomará las medidas técnicas para cumplir dicha solicitud.
            </li>
            <li>
              <strong>Contenido explícito para adultos en plataforma:</strong> La sección
              <em> Video Principal</em> del sitio web ulalaaa.com puede contener videos de contenido
              sexual explícito, de acceso exclusivo para mayores de 18 años. El publicante que autorice
              la inclusión de este tipo de material lo hace de forma libre, informada y voluntaria,
              conforme a lo declarado en el proceso de registro. Este contenido está destinado
              exclusivamente a la plataforma interna de Ulalaaa y <strong>no será difundido en
              redes sociales</strong>.
            </li>
            <li>
              <strong>Publicación pausada:</strong> Cuando el publicante pause voluntariamente su
              publicación, se entiende que tiene intención de reactivarla. Durante este período,
              el contenido subido a la plataforma de video y el material promocional publicado en
              redes sociales <strong>permanecerá visible</strong>, dado que el servicio no ha sido
              cancelado.
            </li>
            <li>
              <strong>Publicación caducada sin renovación:</strong> Si la publicación llega a su
              fecha de vencimiento y el publicante no la renueva, dispondrá de un plazo de
              <strong> 90 días corridos (3 meses)</strong> para reactivarla. Transcurrido dicho
              plazo sin renovación, Ulalaaa procederá a la <strong>eliminación definitiva</strong>
              de la publicación junto con todo el contenido asociado, incluyendo los videos subidos
              a la plataforma y el material promocional publicado en redes sociales administradas
              por Ulalaaa.
            </li>
            <li>
              <strong>Baja total solicitada por el publicante:</strong> Si el publicante solicita
              expresamente la cancelación definitiva de su cuenta escribiendo a
              <a href="mailto:infoulalaaa@gmail.com" className="tl-link"> infoulalaaa@gmail.com</a>,
              Ulalaaa procederá a la eliminación de todo su contenido visible dentro de un plazo
              máximo de <strong>30 días hábiles</strong> desde la recepción de la solicitud.
              Los registros internos de verificación (documentos de identidad y video de
              verificación) se conservarán por hasta 1 año adicional conforme a lo indicado
              en la Política de Privacidad.
            </li>
          </ul>

          <h2 className="tl-titulo">14. Contacto</h2>
          <p className="tl-parrafo">
            Para consultas relacionadas con estos Términos y Condiciones, puede contactarnos en:
            <a href="mailto:infoulalaaa@gmail.com" className="tl-link"> infoulalaaa@gmail.com</a>
          </p>
        </section>

        <div className="tl-divisor" />

        {/* --------------------------------------
            SECCIÓN 2 — POLÍTICA DE PRIVACIDAD
        -------------------------------------- */}
        <section id="privacidad" className="tl-section">
          <h1 className="tl-main-title">Política de Privacidad</h1>
          <p className="tl-fecha">Última actualización: junio de 2026</p>

          <p className="tl-parrafo">
            En Ulalaaa nos comprometemos a proteger la privacidad de nuestros usuarios de acuerdo
            con la <strong>Ley N° 19.628 sobre Protección de la Vida Privada</strong> de Chile y su
            normativa complementaria.
          </p>

          <h2 className="tl-titulo">1. Responsable del Tratamiento de Datos</h2>
          <p className="tl-parrafo">
            Ulalaaa, plataforma publicitaria digital operada en Chile. Contacto:
            <a href="mailto:infoulalaaa@gmail.com" className="tl-link"> infoulalaaa@gmail.com</a>
          </p>

          <h2 className="tl-titulo">2. Datos que Recopilamos</h2>
          <ul className="tl-lista">
            <li><strong>Publicantes:</strong> nombre, correo electrónico, número de teléfono, fotografías,
            videos de verificación, documento de identidad (para verificación interna, no publicado),
            información del anuncio.</li>
            <li><strong>Viewers:</strong> correo electrónico, contraseña encriptada, valoraciones
            realizadas.</li>
            <li><strong>Visitantes:</strong> dirección IP, tipo de navegador, páginas visitadas,
            tiempo de permanencia (datos anónimos de analítica).</li>
          </ul>

          <h2 className="tl-titulo">3. Finalidad del Tratamiento</h2>
          <ul className="tl-lista">
            <li>Gestionar el registro, verificación y publicación de anuncios.</li>
            <li>Administrar cuentas de usuarios y viewers.</li>
            <li>Procesar pagos de suscripciones.</li>
            <li>Mantener la seguridad e integridad de la plataforma.</li>
            <li>Cumplir obligaciones legales ante autoridades competentes cuando corresponda.</li>
          </ul>

          <h2 className="tl-titulo">4. Almacenamiento y Seguridad</h2>
          <p className="tl-parrafo">
            Los datos personales se almacenan en servidores con medidas de seguridad técnicas y
            organizativas para prevenir acceso no autorizado, pérdida o alteración. Los documentos
            de identidad utilizados para verificación se almacenan de forma cifrada y son accesibles
            únicamente por el equipo administrador de Ulalaaa.
          </p>
          <p className="tl-parrafo">
            Los datos de verificación (documentos de identidad y videos) se conservan durante
            el período de actividad de la cuenta y hasta 1 año después de su cierre, como respaldo
            ante eventuales reclamaciones legales.
          </p>

          <h2 className="tl-titulo">5. Compartición de Datos con Terceros</h2>
          <p className="tl-parrafo">
            Ulalaaa <strong>no vende ni cede datos personales a terceros</strong> con fines comerciales.
            Los datos podrán ser compartidos únicamente en los siguientes casos:
          </p>
          <ul className="tl-lista">
            <li>Cuando sea requerido por autoridades judiciales o policiales competentes mediante
            orden legal.</li>
            <li>Con proveedores de servicios técnicos (hosting, procesadores de pago) bajo acuerdos
            de confidencialidad.</li>
          </ul>

          <h2 className="tl-titulo">6. Derechos del Titular de Datos</h2>
          <p className="tl-parrafo">
            De acuerdo con la Ley N° 19.628, usted tiene derecho a:
          </p>
          <ul className="tl-lista">
            <li><strong>Acceso:</strong> solicitar información sobre los datos personales que el
            Sitio posee sobre usted.</li>
            <li><strong>Rectificación:</strong> solicitar la corrección de datos incorrectos
            o desactualizados.</li>
            <li><strong>Cancelación:</strong> solicitar la eliminación de sus datos cuando ya no
            sean necesarios para el fin con que fueron recopilados.</li>
            <li><strong>Oposición:</strong> oponerse al tratamiento de sus datos en determinadas
            circunstancias.</li>
          </ul>
          <p className="tl-parrafo">
            Para ejercer estos derechos, escriba a:
            <a href="mailto:infoulalaaa@gmail.com" className="tl-link"> infoulalaaa@gmail.com</a>
          </p>

          <h2 className="tl-titulo">7. Contacto</h2>
          <p className="tl-parrafo">
            Consultas sobre privacidad:
            <a href="mailto:infoulalaaa@gmail.com" className="tl-link"> infoulalaaa@gmail.com</a>
          </p>
        </section>

        <div className="tl-divisor" />

        {/* --------------------------------------
            SECCIÓN 3 — POLÍTICA DE COOKIES
        -------------------------------------- */}
        <section id="cookies" className="tl-section">
          <h1 className="tl-main-title">Política de Cookies</h1>
          <p className="tl-fecha">Última actualización: junio de 2026</p>

          <h2 className="tl-titulo">¿Qué son las cookies?</h2>
          <p className="tl-parrafo">
            Las cookies son pequeños archivos de texto que se almacenan en su navegador cuando
            visita un sitio web. Permiten que el sitio recuerde sus preferencias y mantenga
            su sesión activa.
          </p>

          <h2 className="tl-titulo">Cookies que utilizamos</h2>
          <ul className="tl-lista">
            <li><strong>Cookies de sesión:</strong> necesarias para mantener su sesión iniciada
            mientras navega el Sitio. Se eliminan al cerrar el navegador.</li>
            <li><strong>Cookies de preferencias:</strong> recuerdan sus configuraciones dentro
            del Sitio (por ejemplo, si ha iniciado sesión como Viewer).</li>
            <li><strong>Cookies de analítica:</strong> nos ayudan a entender cómo los usuarios
            navegan el Sitio para mejorar su funcionamiento. Los datos son anónimos y
            agregados.</li>
          </ul>

          <h2 className="tl-titulo">Cómo desactivar las cookies</h2>
          <p className="tl-parrafo">
            Puede configurar su navegador para bloquear o eliminar cookies. Tenga en cuenta
            que desactivar las cookies de sesión puede afectar el funcionamiento del Sitio,
            como el sistema de inicio de sesión.
          </p>

          <h2 className="tl-titulo">Contacto</h2>
          <p className="tl-parrafo">
            Consultas sobre cookies:
            <a href="mailto:infoulalaaa@gmail.com" className="tl-link"> infoulalaaa@gmail.com</a>
          </p>
        </section>

        {/* Footer interno */}
        <div className="tl-footer-interno">
          <p>©2026 Ulalaaa — Todos los derechos Reservados.</p>
          <a href="/" className="tl-volver">? Volver al inicio</a>
        </div>

      </div>
    </div>
  );
}

export default TextosLegales;